module.exports = __webpack_public_path__ + "static/media/Color-diamonds.b038cff5.png";